<div>
    <hs-legend-vector-layer *ngIf="layer.type === 'vector' && layer.autoLegend" [svg]="layer.svg">
    </hs-legend-vector-layer>
    <div *ngIf="layer.type === 'wms'">
        <img *ngFor="let sublayer of layer.subLayerLegends" [src]="sublayer"
            onerror=" this.parentNode.removeChild(this); "
            onload="if(this.height<6) { this.parentNode.removeChild(this); }">
    </div>
    <div *ngIf="layer.type === 'vector'">
        <p *ngFor="let category of layer.lyr.getSource()?.legend_categories"><!-- TODO: Remove function call from template --><span
                [ngStyle]="{'background-color': category.color}">&nbsp;&nbsp;&nbsp;</span>&nbsp;{{category.name}}
        </p>
    </div>
    <hs-legend-layer-static *ngIf="layer.type === 'static'" [layer]="layer"></hs-legend-layer-static>
</div>
